import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _41b16f9a = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _670717c1 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _2c44297e = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _43c324ac = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _80f83bb4 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _6bc40c5e = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _6b266446 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _23490c42 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _17d88fba = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _d220bfce = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _744d9e4e = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _73e83764 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _8cfd8e0e = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _3baa0960 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _359fb16f = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _aa0419b4 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _6a342214 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _c175b9e2 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _69890944 = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _568c5138 = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _41b16f9a,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _670717c1,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _2c44297e,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _43c324ac,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _80f83bb4,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _6bc40c5e,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _6bc40c5e,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _6bc40c5e,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _6b266446,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _23490c42,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _17d88fba,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _23490c42,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _17d88fba,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _d220bfce,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _d220bfce,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _d220bfce,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _d220bfce,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _d220bfce,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _d220bfce,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _d220bfce,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _744d9e4e,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _744d9e4e,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _73e83764,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _8cfd8e0e,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _8cfd8e0e,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _3baa0960,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _359fb16f,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _aa0419b4,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _aa0419b4,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _6a342214,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _c175b9e2,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _69890944,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _568c5138,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
